import React, { useState, useEffect } from "react";
import axios from "axios";
import { Row, Col } from "react-bootstrap";
import { IoMdCloseCircleOutline } from "react-icons/io";
import notify from "../../ReusableComponents/ToastifyAlerts";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
const AddEditQBAdmin = (props) => {
  const [subjectId, setSubjectId] = useState(
    props.EditDetails?.subjectId || ""
  );
  const [ErrorMessage, setErrors] = useState({});
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const subjects = {
    1: "Mathematics",
    2: "Science",
    3: "English",
    4: "Hindi",
    5: "Telugu"
  };
  const [UDetails, SetUDetails] = useState({
    FirstName: props.EditDetails?.firstName || "",
    LastName: props.EditDetails?.lastName || "",
    LoginId: props.EditDetails?.loginId || "",
  });

  const validationSchema = Yup.object().shape({
    FirstName: Yup.string()
      .matches(
        /^[A-Za-z\s]+$/,
        "First Name should only contain alphabets and spaces"
      )
      .max(50, "First Name cannot exceed 50 characters")
      .required("First Name  is required")
      .test(
        "no-start-space",
        "First Name cannot start with a space",
        (value) => !/^\s/.test(value)
      ),
    LastName: Yup.string()
      .matches(
        /^[A-Za-z\s]+$/,
        "Last Name should only contain alphabets and spaces"
      )
      .max(50, "Last Name cannot exceed 50 characters")
      .required("Last Name  is required")
      .test(
        "no-start-space",
        "Last Name cannot start with a space",
        (value) => !/^\s/.test(value)
      ),
    LoginId: Yup.string()
      .max(50, "LoginId cannot exceed 50 characters")
      .required("LoginId  is required"),
    subjectId: Yup.string().required("Subject  is required"),
  });

  const FIllDetails = (e) => {
    SetUDetails({
      ...UDetails,
      [e.target.name]: e.target.value,
    });
  };

  const SubmitForm = () => {
    const fullUserDetails = { ...UDetails, subjectId };
    validationSchema
      .validate(fullUserDetails, { abortEarly: false })
      .then(() => {
        PostAddUser(fullUserDetails);
      })
      .catch((err) => {
        const newErrors = {};
        err.inner.forEach((error) => {
          newErrors[error.path] = error.message;
        });
        console.log(newErrors);
        setErrors(newErrors);
      });
  };
  const PostAddUser = async (fullUserDetails) => {
    const AddUserDetails = {
      firstName: fullUserDetails.FirstName,
      lastName: fullUserDetails.LastName,
      loginId: fullUserDetails.LoginId,
      subjectId: subjectId,
      isActive: 1,
      isQBAdmin: 1,
      userTypeId: 7,
      userId: props.EditDetails?.userId,
      modifiedBy: items.userId,
      createdBy: items.userId,
    };
    if (props.EditDetails) {
      await axios
        .post(
          process.env.REACT_APP_API_BASE_URL + "/NCLAdmin/UpdateUsers",
          AddUserDetails,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )
        .then(() => {
          props.Cancle(false);
          props.GetList();
          notify("User Updated successfully", "success");
        })
        .catch((err) => {
          notify(
            "An error occurred while updating the user. Please try again.",
            "error"
          );
        });
    } else {
      await axios
        .post(
          process.env.REACT_APP_API_BASE_URL + "/NCLAdmin/InsertUsers",
          AddUserDetails,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )
        .then(() => {
          props.Cancle(false);
          props.GetList();
          notify("User saved successfully", "success");
        })
        .catch((err) => {
          // notify("An error occurred while saving the user. Please try again.", "error")
          setErrors({ ...ErrorMessage, LoginId: "LoginId already exist" });
        });
    }
  };

  return (
    <>
      <div
        className="Card AddStudent-maindiv p-3"
        style={{ width: "900px", margin: "0 auto" }}
      >
        <div className="dflex alignitems JSBetween">
          <div className="AddStudent-Title Helvetica">
            {" "}
            {props.EditDetails ? "Edit" : "Add"} QBAdmin{" "}
          </div>{" "}
          <IoMdCloseCircleOutline onClick={() => props.Cancle(false)} />
        </div>
        <div className="container-fluid">
          <Row>
            <Col md={4}>
              <div className="DropdownHeader">
                First Name<span>*</span>
              </div>
              <input
                type="text"
                name="FirstName"
                value={UDetails.FirstName}
                placeholder="Enter First Name"
                className="NCLDropdown w-100"
                onChange={FIllDetails}
                // disabled
              />
              {ErrorMessage.FirstName && (
                <div className="error-message">{ErrorMessage.FirstName}</div>
              )}
            </Col>
            <Col md={4}>
              <div className="DropdownHeader">
                Last Name<span>*</span>
              </div>
              <input
                type="text"
                name="LastName"
                placeholder="Enter Last Name"
                value={UDetails.LastName}
                className="NCLDropdown w-100"
                onChange={FIllDetails}
                // disabled
              />
              {ErrorMessage.LastName && (
                <div className="error-message">{ErrorMessage.LastName}</div>
              )}
            </Col>
            <Col md={4}>
              <div className="DropdownHeader">
                LoginId<span>*</span>
              </div>
              <input
                type="text"
                name="LoginId"
                placeholder="Enter LoginId"
                value={UDetails.LoginId}
                className="NCLDropdown w-100"
                onChange={FIllDetails}
                //  disabled
              />
              {ErrorMessage.LoginId && (
                <div className="error-message">{ErrorMessage.LoginId}</div>
              )}
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <div className="DropdownHeader">
                UserType<span>*</span>
              </div>
              <input
                type="text"
                name="LoginId"
                value="QBAdmin"
                className="NCLDropdown w-100"
                disabled
              />
            </Col>
            <Col md={4}>
              <div className="DropdownHeader">
                Subject<span>*</span>
              </div>
              <select
                className="NCLDropdown w-100"
                // value={UDetails.subjects}subjectId
                value={subjectId}
                name="subjects"
                onChange={(e) => setSubjectId(e.target.value)}
              >
                <option value="">Select Subject</option>
                {Object.entries(subjects).map(([id, name]) => (
                  <option key={id} value={id}>
                    {name}
                  </option>
                ))}
              </select>
              {ErrorMessage.subjectId && (
                <div className="error-message">{ErrorMessage.subjectId}</div>
              )}
            </Col>
          </Row>
        </div>
        <div className="AddStudent-Buttons dflex mt-3">
          <button className="Buttons" onClick={SubmitForm}>
            {props.EditDetails ? "Update" : "Save"}
          </button>
          <button
            className="Buttons CancleButton"
            onClick={() => props.Cancle(false)}
          >
            Cancel
          </button>
        </div>
      </div>
    </>
  );
};
export default AddEditQBAdmin;
